import React, { Component } from 'react';
import DXFParser from 'dxf-parser';

import store from '../../../../store';
import { setFloorMapLayerProperties, setStoreUpdated } from '../../../../store/actions/Store';

class DxfParserAPI extends Component {
    state = {
        width: null,
        depth: null,
        offsetX: null,
        offsetY: null
    };
    abortController = new AbortController();

    componentDidMount() {
        const { layer, url } = this.props;

        if(!url) {
            return;
        }
        
        fetch(url, {signal: this.abortController.signal})
            .then((response) => response.blob())
            .then((data) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const dxfData = e.target.result;
                    const parser = new DXFParser();
                    const parsedData = parser.parseSync(dxfData);

                    let minX, minY, maxX, maxY = undefined;

                    parsedData.entities.forEach((entity) => {
                        if(entity.layer === layer) {
                            if(entity.type !== 'LWPOLYLINE')
                            {
                                return;
                            }

                            if(entity.vertices) {
                                entity.vertices.forEach((vertex) => {
                                    if(!minX && !minY && !maxX && !maxY) {
                                        minX = vertex.x;
                                        minY = vertex.y;
                                        maxX = vertex.x;
                                        maxY = vertex.y;
                                    }
                                    
                                    if(vertex.x < minX) {
                                        minX = vertex.x;
                                    }
                                    
                                    if(vertex.y < minY) {
                                        minY = vertex.y;
                                    }
                                    
                                    if(vertex.x > maxX) {
                                        maxX = vertex.x;
                                    }
                                    
                                    if(vertex.y > maxY) {
                                        maxY = vertex.y;
                                    }
                                })
                            } else {
                                //console.log(entity);
                            }
                        }
                    })

                    console.log('EXTMIN', parsedData.header.$EXTMIN);
                    console.log('EXTMAX', parsedData.header.$EXTMAX);

                    this.width = (maxX - minX);
                    this.depth = (maxY - minY);
                    this.offsetX = -(maxX - minX) / 100 / 2 - 15;
                    this.offsetY = -(maxY - minY) / 100 / 2 + 5;

                    store.dispatch(setFloorMapLayerProperties({
                        width: this.width,
                        depth: this.depth,
                        offsetX: this.offsetX,
                        offsetY: this.offsetY,
                    }));

                    console.log('width', maxX - minX);
                    console.log('depth', maxY - minY);

                    console.log('offsetX', Number(minX) / 100);
                    console.log('offsetY', Number(minY) / 100);
                };

                reader.readAsText(data);
        })
        .catch((error) => {
            if (error.name === "AbortError") {
                // Request was aborted
                console.log("Request aborted");
              }
            console.error('Error fetching or parsing DXF file:', error);
        });
    }

    componentDidUpdate () {
        const { storeUpdated } = this.props;

        if(storeUpdated) {
            store.dispatch(setFloorMapLayerProperties({
                width: this.width,
                depth: this.depth,
                offsetX: this.offsetX,
                offsetY: this.offsetY,
            }));
        }

        store.dispatch(setStoreUpdated(false));
    }

    componentWillUnmount() {
        this.abortController.abort();
    }

    render() {
        return <div>Loading DXF data from the API...</div>;
    }
}

export default DxfParserAPI;